const CreateRadioButton_mutate = `
    mutation createRadiobutton(
      $formId: Int!,
      $infoTxt: String!,
	  $manAnswer: Boolean!,
      $queText: String!,
      $capText: String!,      
      $options: [String!]!
      ) {
      createRadiobutton(
        formId: $formId,
        infoTxt: $infoTxt,
		manAnswer: $manAnswer,
        queText: $queText,
        capText: $capText,        
        options: $options) {
        component
        {
          componentId
          label
          caption
        }
      }
    }
`;

const EditRadioButton_mutate = `
  mutation editRadioButton(
    $componentId: Int!
    $label: String!  
    $mandatory: Boolean
    $caption: String
    $tooltip: String
    $options: [String!]!
    ) {
    editRadiobutton(
      componentId: $componentId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,
      options: $options) 
      {
        component {
          componentId
          answerList{
            answerId 
            label
            value
          }
          caption
          tooltip
          order
          label
          mandatory          
        }
      }
    }
`;

module.exports = {
  CREATE_RADIOBUTTON_MUTATION : CreateRadioButton_mutate,
  EDIT_RADIOBUTTON_MUTATION : EditRadioButton_mutate,
}
